module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-marriage-certificate-8e0b097bff8e596e3254f92385665621.jpg";